export default __webpack_public_path__ + "static/egypt-for-first-time-adventurers-cbdcdabcb49d59687a608df585a30394.jpg";